import { render, staticRenderFns } from "./OnHold.vue?vue&type=template&id=ce6ecb24"
import script from "./OnHold.vue?vue&type=script&lang=ts"
export * from "./OnHold.vue?vue&type=script&lang=ts"
import style0 from "./OnHold.vue?vue&type=style&index=0&id=ce6ecb24&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports